import MediaInfo from "./MediaInfo";

export default MediaInfo;
